<script setup lang="ts">
import { getCountryDomain } from '@/utils/routers'
import { SEOMaker } from '@/utils/seoMaker'

import { useNuxtApi } from '@/composables/useNuxtApi'

import HtmlContent from '@/components/Flatpages/HtmlContent.vue'

import { DEFAULT_SLUG_DATA, SLUG_PAGE_DATA } from '@@/constants/terms-of-use'
import type { ConfidentialData } from '@@/server/types/common'

const { $host } = useNuxtApp()
const route = useRoute()

const cityDataForCurrentDomain = computed(() => {
  const { $host } = useNuxtApp()
  const countryDomain = getCountryDomain($host)

  return (
    SLUG_PAGE_DATA[countryDomain as keyof typeof SLUG_PAGE_DATA] ||
    DEFAULT_SLUG_DATA
  )
})

const pageTitle = computed(
  () => cityDataForCurrentDomain.value?.title || 'Farfor',
)

const { data: fetchedData } = await useNuxtApi<ConfidentialData>(
  '/api/flatpages',
  {
    query: {
      city: cityDataForCurrentDomain.value?.city,
      path: '/terms_of_use/',
    },
  },
)

const breadcrumbs = computed(() => {
  return [
    { text: `Главная`, href: '/' },
    { text: 'Пользовательское соглашение', href: '/terms-of-use/' },
  ]
})

const confidentialPageContent = computed(() => fetchedData.value?.content || '')

useHead({
  title: pageTitle.value,
  ...SEOMaker(
    $host,
    {
      title: pageTitle.value,
      keywords: '',
      description: cityDataForCurrentDomain.value?.description || '',
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="terms-of-use">
    <the-breadcrumbs
      class="terms-of-use__breadcrumbs"
      theme="dark"
      :domain="$host"
      :breadcrumbs="breadcrumbs"
    />

    <html-content :page-content="confidentialPageContent" />
  </div>
</template>

<style scoped lang="scss">
.terms-of-use {
  padding: 42px 20px 40px 20px;

  @include media('>=tablet') {
    padding: 60px 20px 40px 20px;
  }

  @include media('>=desktop-mini') {
    padding: 80px 0 100px 0;
  }

  &__breadcrumbs {
    margin-bottom: 20px;
  }
}
</style>
